import type { ErrorBoundaryProps } from '@epihub/web/src/components/ErrorBoundary';

export const errorBoundaryProps = {
  fallbackRender: () => <div>Something went wrong</div>,
} satisfies ErrorBoundaryProps;
